import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import { MultiSelect } from "react-multi-select-component";

const AddEditSchool = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    roleAr: "",
    roleEn: "",
    nameAr: "",
    nameEn: "",
    descriptionEn: "",
    descriptionAr: "",
    isActive: true,
  });
  const handleChangeNameEn = (newValue) => {
    setItem({ ...item, nameEn: newValue });
    setNameEnError("");
  };
  const [nameEnError, setNameEnError] = useState("");

  const handleChangeNameAr = (newValue) => {
    setItem({ ...item, nameAr: newValue });
    setNameArError("");
  };
  const [nameArError, setNameArError] = useState("");

  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [files, setFiles] = useState([]);

  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );

  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];

  const fileUpload = !files.length && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs and jpegs (Required size: 300x300 pixels)"}
    />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const imageKey = useRef("");
  const sendImage = (files) => {
    setItem({
      ...item,
      image:
        validImageTypes.indexOf(files[files.length - 1].type) > 0
          ? window.URL.createObjectURL(files[files.length - 1])
          : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    });
    setImageError("");
  };
  const [optionsClasses, setOptionsClasses] = useState([]);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [classesError, setClassesError] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    let responseItem = "";
    let responseClasses = [];

    try {
      responseClasses = await axios.get(`/classes`);
      console.log("classes=", responseClasses.data.data.data);
      setOptionsClasses(
        responseClasses.data.data.data.map((item, index) => {
          return {
            label: item?.name && getFirstNonNullValue(item.name),
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
    if (props.type === "edit") {
      try {
        responseItem = await axios.get(`/schools/${id}`);
        setItem({
          nameEn:
            responseItem?.data?.data?.name && responseItem?.data?.data?.name?.en
              ? responseItem.data.data.name.en
              : "",
          nameAr:
            responseItem?.data?.data?.name && responseItem?.data?.data?.name?.ar
              ? responseItem.data.data.name.ar
              : "",
          image: responseItem?.data?.data?.image
            ? responseItem.data.data.image
            : "",
          // school:
          //   responseItem?.data?.data?.school !== null
          //     ? {
          //         label: getFirstNonNullValue(
          //           responseItem?.data?.data?.subject?.school
          //         ),
          //         value: String(responseItem?.data?.data?.subject?.id),
          //       }
          //     : "",
          isActive: responseItem?.data?.data?.is_active ? true : false,
        });
        setSelectedClasses(
          responseItem?.data?.data?.school_classes?.map((item, index) => {
            return {
              label: getFirstNonNullValue(item.name),
              value: String(item.id),
            };
          })
        );
      } catch (error) {
        console.log(error);
      }
    }

    setIsSaving(false);
  }
  // useEffect(() => {
  //   props.type === "edit" &&
  //     axios
  //       .get(`/schools/${id}`)
  //       .then((result) => {
  //         console.log(result.data.data);
  //         setItem({
  //           nameEn:
  //             result?.data?.data?.name && result?.data?.data?.name?.en
  //               ? result.data.data.name.en
  //               : "",
  //           nameAr:
  //             result?.data?.data?.name && result?.data?.data?.name?.ar
  //               ? result.data.data.name.ar
  //               : "",
  //           image: result?.data?.data?.image ? result.data.data.image : "",
  //           isActive: result?.data?.data?.is_active ? true : false,
  //         });
  //         setIsSaving(false);
  //       })

  //       .catch((err) => console.log(err));
  // }, []);
  const refId = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/schools/${id}`)
      .then((result) => {
        navigate("/admin/schools");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} School`}
      backAction={{ onAction: () => navigate("/admin/schools") }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              value={item.nameEn}
              onChange={handleChangeNameEn}
              label="Name En"
              error={nameEnError}
              requiredIndicator
            />
            <TextField
              value={item.nameAr}
              onChange={handleChangeNameAr}
              label="Name Ar"
              align="right"
              error={nameArError}
              requiredIndicator
            />
          </FormLayout.Group>

          <Text>
            Logo <span style={{ color: "#8e1f0b" }}>*</span>
          </Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".png,.jpg,.jpeg"
                onDrop={handleDropZoneDrop}
                allowMultiple={false}
                onDropAccepted={sendImage}
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>
          <InlineError message={imageError} />
          <Text>
            Classes <span style={{ color: "#8e1f0b" }}>*</span>
          </Text>

          <div
            style={{
              position: "relative",
              zIndex: 9999,
            }}
          >
            <MultiSelect
              options={optionsClasses}
              onChange={setSelectedClasses}
              value={selectedClasses}
              placeholder="Please select"
            />
          </div>
          <InlineError message={classesError} />
          <div style={{ height: 400 }}></div>
          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>

      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              {isSaving ? <Spinner size="small" /> : "Delete"}
            </Button>
          )
        }
      />

      {/* <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/schools/${id}`)
                  .then((result) => {
                    navigate("/admin/schools");
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      /> */}
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (
      !item.nameEn ||
      !item.nameAr ||
      (props?.type === "add" && !files?.length) ||
      !selectedClasses.length
    ) {
      !item.nameEn && setNameEnError("This field is required");
      !item.nameAr && setNameArError("This field is required");
      props?.type === "add" &&
        !files?.length &&
        setImageError("Please upload a logo");
      !selectedClasses.length &&
        setClassesError("Please select at least one class");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      item.nameEn && form_data.append("name[en]", item.nameEn);
      item.nameAr && form_data.append("name[ar]", item.nameAr);
      files?.length && form_data.append("image", files[0]);
      selectedClasses.forEach((selectedClass, index) =>
        form_data.append(`school_class_ids[${index}]`, selectedClass.value)
      );
      form_data.append("is_active", item.isActive ? 1 : 0);
      props?.type === "edit" && form_data.append("_method", "PATCH");

      props.type === "add"
        ? axios
            .post(`/schools`, form_data)
            .then((result) => {
              navigate("/admin/schools");
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/schools/${id}`, form_data)
            .then((result) => {
              navigate("/admin/schools");
              // toggleActive();
              // setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default AddEditSchool;
